export type eventTypeTracking = 'events' | 'trucker_profile' | 'open_search';

export const enum MessageError {
  undefined = 'Não foi possível conectar ao servidor.',
  duplicated = 'Resposta invalida por conta de duplicidade',
  notActive = 'Motorista inativo na plataforma.',
  notFound = 'cpf or phone not found',
}
